<template>
  <component class="fs-db-28" :is="tag" v-html="label"></component>
</template>

<script>
export default {
  props: {
    tag: {
      type: String,
      default: "span",
    },
    label: {
      type: String,
      default: "",
    },
  },
};
</script>